/**
 * Stable CSS class names for E2E — Customer gift cards.
 */
export const CGC = {
    page: 'customer-gift-card-page',
    paperGiftCards: 'customer-gift-card-page__paper-gift-cards',
    paperTransactions: 'customer-gift-card-page__paper-transactions',
    titleGiftCards: 'customer-gift-card-page__title-gift-cards',
    fieldRefundBalance: 'customer-gift-card-field--refund-balance',
    datagridGiftCards: 'customer-gift-card-page__datagrid-gift-cards',
    titleTransactions: 'customer-gift-card-page__title-transactions',
    gridTransactions: 'customer-gift-card-page__grid-transactions',
    datagridTransactions: 'customer-gift-card-page__datagrid-transactions',

    fieldChipCardStatus: 'customer-gift-card-field--chip-card-status',
} as const;

export const cgcCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
